const translations = {
  disaggregated: 'FINANCE.SALES_CHART.DISAGGREGATED_SALES',
  total: 'FINANCE.SALES_CHART.TOTAL_SALE',
};
export default function getChartModeLabel(mode) {
  const label = translations[mode];
  return label ? label : '';
}
